import { create } from 'zustand';

interface PageBlockState {
  blocking: boolean;
  setBlocking: (blocking: boolean) => void;
}

export const usePageBlockStore = create<PageBlockState>((set) => ({
  blocking: false,
  setBlocking: (blocking) => set({ blocking }),
}));
